export enum WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum {
  NonWorkingDay = 'non_working_day',
  Holiday = 'holiday',
  Vacation = 'vacation',
  Absence = 'absence',
  PartialAbsence = 'partial_absence',
}

export function getNonWorkingDayAlertReasonEmoji(
  reason: WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum | null
): string | null {
  switch (reason) {
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.Vacation:
      return '🌴';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.Holiday:
      return '🎆';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.Absence:
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.PartialAbsence:
      return '🪑';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.NonWorkingDay:
      return '💤';
    default:
      return null;
  }
}

export function getNonWorkingDayAlertReasonTooltip(
  reason: WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum | null
): string | null {
  switch (reason) {
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.Vacation:
      return 'Vacaciones';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.Holiday:
      return 'Festivo';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.Absence:
      return 'Ausencia total';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.PartialAbsence:
      return 'Ausencia parcial';
    case WorkingContractWeeklyScheduleExceptionRequestNonWorkingDayAlertReasonEnum.NonWorkingDay:
      return 'Día no laborable';
    default:
      return null;
  }
}
